module.exports = __webpack_public_path__ + "img/about_factory.70de458b.jpg";